import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './map-view.css'

const MapView = (props) => {
  return (
    <div className="map-view-container1">
      <Helmet>
        <title>Map-View - BidWally</title>
        <meta
          property="og:title"
          content="Map-View - BidWally"
        />
        <link
          rel="canonical"
          href="https://bidwally.com/map-view"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="map-explorer">
        <div className="map-explorer-container">
          <div className="map-visual-pane">
            <div className="map-placeholder">
              <div className="map-view-thq-map-pin-cluster-elm map-pin-cluster cluster-primary">
                <span className="cluster-count">24</span>
              </div>
              <div className="map-view-thq-map-pin-single-elm1 map-pin-single verified">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </g>
                </svg>
              </div>
              <div className="map-view-thq-map-pin-single-elm2 map-pin-single featured">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </g>
                </svg>
              </div>
            </div>
            <div className="map-controls">
              <button aria-label="Zoom in" className="map-control-btn">
                +
              </button>
              <button aria-label="Zoom out" className="map-control-btn">
                −
              </button>
            </div>
          </div>
          <div className="map-listing-pane">
            <div className="listing-pane-header">
              <h1 className="hero-title">Local Listings</h1>
              <p className="section-subtitle">
                Discover items nearby in Seattle, WA
              </p>
            </div>
            <div className="listing-results-stack">
              <div className="map-listing-card">
                <div className="card-image-wrapper">
                  <img
                    src="https://images.pexels.com/photos/7286173/pexels-photo-7286173.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Luxury Watch"
                    className="card-img"
                  />
                  <span className="badge-verified">Verified</span>
                </div>
                <div className="card-content">
                  <div className="card-price-row">
                    <span className="crypto-price">0.045 BTC</span>
                    <span className="fiat-reference">≈ $2,840.00</span>
                  </div>
                  <h3 className="card-title">Rolex Submariner 2022</h3>
                  <p className="card-location">Downtown • 0.8 miles away</p>
                  <div className="card-actions">
                    <button className="btn btn-primary btn-sm">
                      View Listing
                    </button>
                    <button className="btn btn-sm btn-outline">Message</button>
                  </div>
                </div>
              </div>
              <div className="map-listing-card">
                <div className="card-image-wrapper">
                  <img
                    src="https://images.pexels.com/photos/6872164/pexels-photo-6872164.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Tesla Model 3"
                    className="card-img"
                  />
                </div>
                <div className="card-content">
                  <div className="card-price-row">
                    <span className="crypto-price">12.5 ETH</span>
                    <span className="fiat-reference">≈ $32,150.00</span>
                  </div>
                  <h3 className="card-title">Tesla Model 3 Performance</h3>
                  <p className="card-location">Capitol Hill • 2.4 miles away</p>
                  <div className="card-actions">
                    <button className="btn btn-primary btn-sm">
                      View Listing
                    </button>
                    <button className="btn btn-sm btn-outline">Message</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="filter-bar">
        <div className="filter-bar-container">
          <div className="filter-controls-primary">
            <div className="filter-group">
              <label className="filter-label">Price Range</label>
              <div className="filter-input-row">
                <input
                  type="text"
                  placeholder="Min Fiat"
                  className="filter-input"
                />
                <input
                  type="text"
                  placeholder="Max Fiat"
                  className="filter-input"
                />
              </div>
            </div>
            <div className="filter-group">
              <label className="filter-label">Distance</label>
              <select className="filter-select">
                <option>Within 5 miles</option>
                <option>Within 10 miles</option>
                <option>Within 25 miles</option>
                <option>Region-wide</option>
              </select>
            </div>
            <div className="filter-toggle-group">
              <label className="toggle-switch">
                <input type="checkbox" />
                <span className="map-view-thq-toggle-slider-elm"></span>
              </label>
              <span className="toggle-label">Escrow Only</span>
            </div>
            <button className="btn btn-sm btn-accent">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 4h16v2.172a2 2 0 0 1-.586 1.414L15 12v7l-6 2v-8.5L4.52 7.572A2 2 0 0 1 4 6.227z"></path>
              </svg>
              <span>
                {' '}
                Advanced Filters
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </button>
          </div>
          <div className="filter-scroller-wrapper">
            <div className="filter-scroller-track">
              <button className="category-chip active">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"></path>
                    <circle cx="7" cy="17" r="2"></circle>
                    <path d="M9 17h6"></path>
                    <circle cx="17" cy="17" r="2"></circle>
                  </g>
                </svg>
                <span>
                  {' '}
                  Vehicles
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </button>
              <button className="category-chip">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M18 5a2 2 0 0 1 2 2v8.526a2 2 0 0 0 .212.897l1.068 2.127a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45l1.068-2.127A2 2 0 0 0 4 15.526V7a2 2 0 0 1 2-2zm2.054 10.987H3.946"
                  ></path>
                </svg>
                <span>
                  {' '}
                  Electronics
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </button>
              <button className="category-chip">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205l3 1m1.5.5l-1.5-.5M6.75 7.364V3h-3v18m3-13.636l10.5-3.819"
                  ></path>
                </svg>
                <span>
                  {' '}
                  Housing
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </button>
              <button className="category-chip">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                    <rect width="20" height="14" x="2" y="6" rx="2"></rect>
                  </g>
                </svg>
                <span>
                  {' '}
                  Jobs
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </button>
              <button className="category-chip">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="3" width="18" height="18" rx="2"></rect>
                  <path d="M3 9h18"></path>
                  <path d="M9 21V9"></path>
                </svg>
                <span>
                  {' '}
                  Digital Goods
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </button>
              <button className="category-chip">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M12 8v8"></path>
                  <path d="M8 12h8"></path>
                </svg>
                <span>
                  {' '}
                  Collectibles
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="map-legend-features">
        <div className="legend-container">
          <div className="legend-header">
            <h2 className="section-title">Map Intelligence</h2>
            <p className="section-content">
              Understand the local crypto landscape with our trust-driven visual
              indicators.
            </p>
          </div>
          <div className="legend-grid">
            <div className="legend-item">
              <div className="legend-icon verified">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="legend-text">
                <h3 className="section-subtitle">Verified Sellers</h3>
                <p className="section-content">
                  Identity-verified users with a history of successful
                  peer-to-peer trades.
                </p>
              </div>
            </div>
            <div className="legend-item">
              <div className="legend-icon flagged">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m21.73 18l-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3M12 9v4m0 4h.01"
                  ></path>
                </svg>
              </div>
              <div className="legend-text">
                <h3 className="section-subtitle">Community Flags</h3>
                <p className="section-content">
                  Listings flagged by the community for suspicious activity or
                  safety concerns.
                </p>
              </div>
            </div>
            <div className="legend-item">
              <div className="legend-icon featured">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="m8.243 7.34l-6.38.925l-.113.023a1 1 0 0 0-.44 1.684l4.622 4.499l-1.09 6.355l-.013.11a1 1 0 0 0 1.464.944l5.706-3l5.693 3l.1.046a1 1 0 0 0 1.352-1.1l-1.091-6.355l4.624-4.5l.078-.085a1 1 0 0 0-.633-1.62l-6.38-.926l-2.852-5.78a1 1 0 0 0-1.794 0z"
                  ></path>
                </svg>
              </div>
              <div className="legend-text">
                <h3 className="section-subtitle">Featured Listings</h3>
                <p className="section-content">
                  Promoted items from highly-rated sellers with priority map
                  placement.
                </p>
              </div>
            </div>
            <div className="legend-item">
              <div className="legend-icon safety">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
              </div>
              <div className="legend-text">
                <h3 className="section-subtitle">Safety Heatmap</h3>
                <p className="section-content">
                  Visual guide to community-vetted safe meeting zones and
                  exchange points.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="results-grid-view">
        <div className="results-tabs-container">
          <div className="tabs-header">
            <div role="tablist" className="tabs-list">
              <button
                role="tab"
                aria-selected="true"
                className="tab-trigger active"
              >
                Grid View
              </button>
              <button role="tab" aria-selected="false" className="tab-trigger">
                List View
              </button>
              <button role="tab" aria-selected="false" className="tab-trigger">
                Safety Tips
              </button>
            </div>
            <div className="results-sort">
              <span className="sort-label">Sort by:</span>
              <select className="filter-select">
                <option>Closest</option>
                <option>Newest</option>
                <option>Highest Reputation</option>
              </select>
            </div>
          </div>
          <div className="tab-content-panel">
            <div className="results-grid">
              <div className="listing-product-card">
                <img
                  src="https://images.pexels.com/photos/10396179/pexels-photo-10396179.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Apartment"
                  className="product-img"
                />
                <div className="product-info">
                  <span className="product-category">Housing</span>
                  <h3 className="section-subtitle">Modern Studio Downtown</h3>
                  <div className="product-price-block">
                    <span className="crypto-val">0.85 ETH / mo</span>
                    <span className="fiat-val">≈ $2,100</span>
                  </div>
                  <div className="product-meta">
                    <span className="meta-item">Reputation: 4.9/5</span>
                    <span className="meta-item">Seattle, WA</span>
                  </div>
                </div>
              </div>
              <div className="listing-product-card">
                <img
                  src="https://images.pexels.com/photos/1190897/pexels-photo-1190897.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Office Space"
                  className="product-img"
                />
                <div className="product-info">
                  <span className="product-category">Services</span>
                  <h3 className="section-subtitle">Crypto-Co-working Pass</h3>
                  <div className="product-price-block">
                    <span className="crypto-val">120 SOL</span>
                    <span className="fiat-val">≈ $18,400</span>
                  </div>
                  <div className="product-meta">
                    <span className="meta-item">Reputation: 4.7/5</span>
                    <span className="meta-item">Bellevue, WA</span>
                  </div>
                </div>
              </div>
              <div className="listing-product-card">
                <img
                  src="https://images.pexels.com/photos/14353567/pexels-photo-14353567.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Vespa"
                  className="product-img"
                />
                <div className="product-info">
                  <span className="product-category">Vehicles</span>
                  <h3 className="section-subtitle">
                    Vintage Vespa E-Converted
                  </h3>
                  <div className="product-price-block">
                    <span className="crypto-val">0.12 BTC</span>
                    <span className="fiat-val">≈ $7,500</span>
                  </div>
                  <div className="product-meta">
                    <span className="meta-item">Reputation: 5.0/5</span>
                    <span className="meta-item">Fremont, WA</span>
                  </div>
                </div>
              </div>
              <div className="listing-product-card">
                <img
                  src="https://images.pexels.com/photos/226789/pexels-photo-226789.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Tech"
                  className="product-img"
                />
                <div className="product-info">
                  <span className="product-category">Electronics</span>
                  <h3 className="section-subtitle">RTX 4090 - New in Box</h3>
                  <div className="product-price-block">
                    <span className="crypto-val">0.028 BTC</span>
                    <span className="fiat-val">≈ $1,800</span>
                  </div>
                  <div className="product-meta">
                    <span className="meta-item">Reputation: 4.8/5</span>
                    <span className="meta-item">Redmond, WA</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="pagination-controls">
              <button className="btn btn-sm btn-outline">Previous</button>
              <div className="pagination-pages">
                <span className="page-num active">1</span>
                <span className="page-num">2</span>
                <span className="page-num">3</span>
              </div>
              <button className="btn btn-sm btn-outline">Next</button>
            </div>
          </div>
        </div>
      </section>
      <section className="seller-showcase">
        <div className="showcase-container">
          <div className="map-view-showcase-header">
            <h2 className="section-title">Verified Local Sellers</h2>
            <p className="section-content">
              Connect with trusted members of the Seattle crypto community.
            </p>
          </div>
          <div className="seller-rail">
            <div className="seller-card">
              <div className="map-view-seller-avatar">
                <img
                  src="https://images.pexels.com/photos/4473355/pexels-photo-4473355.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Seller"
                  className="avatar-img"
                />
                <span className="status-indicator"></span>
              </div>
              <h3 className="section-subtitle">CryptoElena</h3>
              <div className="seller-stats">
                <div className="stat-item">
                  <span className="stat-value">142</span>
                  <span className="stat-label">Trades</span>
                </div>
                <div className="stat-item">
                  <span className="stat-value">4.9</span>
                  <span className="stat-label">Rating</span>
                </div>
              </div>
              <p className="seller-bio">
                Specializing in high-end electronics and digital assets since
                2021.
              </p>
              <a href="#">
                <div className="btn btn-sm btn-link">
                  <span>View Profile</span>
                </div>
              </a>
            </div>
            <div className="seller-card">
              <div className="map-view-seller-avatar">
                <img
                  src="https://images.pexels.com/photos/8728101/pexels-photo-8728101.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Seller"
                  className="avatar-img"
                />
                <span className="status-indicator"></span>
              </div>
              <h3 className="section-subtitle">BlockExplorer_WA</h3>
              <div className="seller-stats">
                <div className="stat-item">
                  <span className="stat-value">89</span>
                  <span className="stat-label">Trades</span>
                </div>
                <div className="stat-item">
                  <span className="stat-value">5.0</span>
                  <span className="stat-label">Rating</span>
                </div>
              </div>
              <p className="seller-bio">
                Local vehicle enthusiast. Non-custodial escrow preferred for all
                deals.
              </p>
              <a href="#">
                <div className="btn btn-sm btn-link">
                  <span>View Profile</span>
                </div>
              </a>
            </div>
            <div className="seller-card">
              <div className="map-view-seller-avatar">
                <img
                  src="https://images.pexels.com/photos/19784799/pexels-photo-19784799.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Seller"
                  className="avatar-img"
                />
                <span className="status-indicator"></span>
              </div>
              <h3 className="section-subtitle">SatoshiSeattle</h3>
              <div className="seller-stats">
                <div className="stat-item">
                  <span className="stat-value">256</span>
                  <span className="stat-label">Trades</span>
                </div>
                <div className="stat-item">
                  <span className="stat-value">4.8</span>
                  <span className="stat-label">Rating</span>
                </div>
              </div>
              <p className="seller-bio">
                Real estate and long-term rental specialist accepting multiple
                cryptos.
              </p>
              <a href="#">
                <div className="btn btn-sm btn-link">
                  <span>View Profile</span>
                </div>
              </a>
            </div>
            <div className="seller-card">
              <div className="map-view-seller-avatar">
                <img
                  src="https://images.pexels.com/photos/10410074/pexels-photo-10410074.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Seller"
                  className="avatar-img"
                />
                <span className="status-indicator"></span>
              </div>
              <h3 className="section-subtitle">RainierTrades</h3>
              <div className="seller-stats">
                <div className="stat-item">
                  <span className="stat-value">64</span>
                  <span className="stat-label">Trades</span>
                </div>
                <div className="stat-item">
                  <span className="stat-value">4.7</span>
                  <span className="stat-label">Rating</span>
                </div>
              </div>
              <p className="seller-bio">
                General goods seller. Verified and active member of the local
                community.
              </p>
              <a href="#">
                <div className="btn btn-sm btn-link">
                  <span>View Profile</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="map-cta">
        <div className="cta-card-container">
          <div className="cta-inner-card">
            <div className="cta-content">
              <h2 className="section-title">Ready to sell in Seattle?</h2>
              <p className="section-content">
                List your item directly from the map. Your current location is
                pre-filled for faster listing creation.
              </p>
              <div className="cta-actions">
                <button className="btn btn-accent btn-lg">
                  Create New Listing
                </button>
                <button className="btn btn-outline btn-lg">
                  Explore Subscriptions
                </button>
              </div>
              <p className="cta-subtext">
                Featured listings get 5x more map visibility.
              </p>
            </div>
            <div className="cta-visual">
              <div className="cta-map-preview">
                <div className="preview-pulse"></div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="help-panel">
        <div className="help-container">
          <div className="help-header">
            <h2 className="section-title">Map Guide &amp; Safety</h2>
            <p className="section-content">
              Everything you need to know about secure local crypto trading.
            </p>
          </div>
          <div className="help-grid">
            <div className="help-item">
              <h3 className="section-subtitle">How to use the map</h3>
              <p className="section-content">
                Zoom into your neighborhood to see local listings. Pin colors
                indicate seller status: Green for verified, Gold for featured,
                and Red for community warnings.
              </p>
            </div>
            <div className="help-item">
              <h3 className="section-subtitle">Non-Custodial Model</h3>
              <p className="section-content">
                <span>
                  BidWally doesn&apos;t hold your funds. All trades happen
                  peer-to-peer. Learn how our
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <a href="#">
                  <div className="btn-link">
                    <span>escrow roadmap</span>
                  </div>
                </a>
                <span> will enhance this model soon.</span>
              </p>
            </div>
            <div className="help-item">
              <h3 className="section-subtitle">Safe Meeting Tips</h3>
              <p className="section-content">
                Always meet in public, well-lit areas. Use our &quot;Safe
                Zones&quot; heatmap to find community-vetted exchange points
                like police station lobbies or busy cafes.
              </p>
            </div>
            <div className="help-item">
              <h3 className="section-subtitle">Reputation Matters</h3>
              <p className="section-content">
                Check a seller&apos;s on-chain history and community flags
                before initiating a trade. Higher reputation scores correlate
                with smoother transaction experiences.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="map-view-container2">
        <div className="map-view-container3">
          <Script
            html={`<style>
input:checked + .toggle-slider {
  background-color: var(--color-primary);
}
input:checked + .toggle-slider:before {
  transform: translateX(20px);
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="map-view-container4">
        <div className="map-view-container5">
          <Script
            html={`<script defer data-name="map-view-logic">
(function(){
  // Tab switching logic for Grid/List view
  const tabTriggers = document.querySelectorAll('.tab-trigger');
  tabTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      tabTriggers.forEach(t => t.classList.remove('active'));
      trigger.classList.add('active');
    });
  });

  // Category chip selection
  const chips = document.querySelectorAll('.category-chip');
  chips.forEach(chip => {
    chip.addEventListener('click', () => {
      chips.forEach(c => c.classList.remove('active'));
      chip.classList.add('active');
    });
  });

  // Simple horizontal scroller behavior for seller rail
  const rail = document.querySelector('.seller-rail');
  if (rail) {
    let isDown = false;
    let startX;
    let scrollLeft;

    rail.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - rail.offsetLeft;
      scrollLeft = rail.scrollLeft;
    });
    rail.addEventListener('mouseleave', () => { isDown = false; });
    rail.addEventListener('mouseup', () => { isDown = false; });
    rail.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - rail.offsetLeft;
      const walk = (x - startX) * 2;
      rail.scrollLeft = scrollLeft - walk;
    });
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default MapView
